import React, { Component } from "react";
import ApiConnect from "../../../../Utils/ApiConnect";
import ImageSliders from "../../../Components/ImageSliders";
import QuickView from "../../../Components/QuickView";
import Barcode from "react-barcode";
export default class ProductSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productId: props.match.params.id || "",
      productData: [],
      showQuick: false,
      selectedId: false,
      selectedType: false,
      triggerModal: false,
    };
  }
  componentDidMount() {
    ApiConnect.get(
      `/Module/Inventory/Product/Details?id=${this.state.productId}`
    )
      .then((response) => {
        this.setState({
          productData: response.data,
        });
      })
      .catch((error) => console.log(error));
  }
  SetshowQuick = () => {
    this.setState({ showQuick: false });
  };
  render() {
    const productData = this.state.productData;
    return (
      <div className="row g-3 mb-3">
        <div className="col-xl-4 col-lg-4">
          <div className="card mb-3">
            <div className="card-body">
              <div className="card text-center">
                <div>
                  <div className="mb-3">
                    <ImageSliders images={productData.image} />
                  </div>
                </div>
                <h5>{productData.name}</h5>
                <p>
                  <small className="fs-13"> {productData.category}</small>
                </p>
                <p className="text-light fs-12 mb-1">
                  {productData.description}
                </p>
                <p>
                  {productData.tags
                    ? productData.tags.map((name, index) => (
                        <span
                          className="badge badge-pill badge-default m-1"
                          key={index}
                        >
                          {name}
                        </span>
                      ))
                    : ""}
                </p>
                <div className="pt-10">
                  <div className="flexbox">
                    <h6>Name</h6>
                    <p>{productData.name}</p>
                  </div>
                  <div className="flexbox">
                    <h6>Page Title</h6>
                    <p>{productData.title}</p>
                  </div>
                  <div className="flexbox">
                    <h6>Slug</h6>
                    <p>{productData.slug}</p>
                  </div>
                  <div className="flexbox">
                    <h6>Category</h6>
                    <p>{productData.category}</p>
                  </div>
                  <div className="flexbox">
                    <h6>Godown</h6>
                    <p>{productData.godown}</p>
                  </div>
                  <div className="flexbox">
                    <h6>Stock</h6>
                    <span className={`badge badge-pill badge-purple `}>
                      {productData.stock}
                    </span>
                  </div>
                </div>
                <div className="bb-1 h-10px"></div>
                <div className="pt-20">
                  <div className="flexbox">
                    <h6>Cost Price</h6>
                    <p>{productData.costprice}</p>
                  </div>
                  <div className="flexbox">
                    <h6>Selling Price</h6>
                    <p>{productData.sellingprice}</p>
                  </div>
                  <div className="flexbox">
                    <h6>VAT</h6>
                    <p>{productData.pvat}</p>
                  </div>
                  <div className="flexbox">
                    <h6>Qty in Pack</h6>
                    <p>{productData.qtyinpack}</p>
                  </div>
                  <div className="flexbox">
                    <h6>Size</h6>
                    <p>{`${productData.productsize} ${productData.unit}`}</p>
                  </div>
                  <div className="flexbox">
                    <h6>Minimum Alert Quantity</h6>
                    <p>{productData.minqty}</p>
                  </div>
                  <div className="flexbox">
                    <h6>Web Publish</h6>
                    <p>{productData.webview}</p>
                  </div>
                  <div className="text-center">
                    <div className="">
                      {productData.barcode !== "0" && productData.barcode ? (
                        <Barcode value={productData.barcode} />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-8 col-lg-8">
          <div className="card mb-3">
            <div className="card-header py-3 d-flex justify-content-between align-items-center bg-transparent border-bottom-0">
              <h6 className="m-0 fw-bold">Recent Purchase</h6>
            </div>
            <div className="card-body">
              <table className="table table-sm">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Account Head</th>
                    <th>Quantity</th>
                    <th>free</th>
                    <th>rate</th>
                  </tr>
                </thead>
                <tbody>
                  {productData.purchase
                    ? productData.purchase.map((prch, index) => (
                        <tr key={index}>
                          <td>
                            {prch.date} <small>{prch.miti}</small>
                          </td>
                          <td>
                            {prch.account}{" "}
                            <a
                              href="#_"
                              onClick={() =>
                                this.setState({
                                  selectedId: prch.voucher,
                                  showQuick: true,
                                  selectedType: "Purchase Entry",
                                })
                              }
                            >
                              {prch.voucher}
                            </a>
                          </td>
                          <td>{prch.qty}</td>
                          <td>{prch.free}</td>
                          <td>{prch.rate}</td>
                        </tr>
                      ))
                    : ""}
                </tbody>
              </table>
            </div>
          </div>
          <div className="card mb-3">
            <div className="card-header py-3 d-flex justify-content-between align-items-center bg-transparent border-bottom-0">
              <h6 className="m-0 fw-bold">Product Summary</h6>
            </div>
            <div className="card-body">
              <table className="table table-sm">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Account Head</th>
                    <th>Quantity</th>
                    <th>Damage Qty</th>
                    <th>User</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>2022-11-20</th>
                    <td>
                      Mark food and beverage pvt ltd
                      <a href="#Asd">7778PV0129</a>
                    </td>
                    <td>100</td>
                    <td>0</td>
                    <td>user</td>
                  </tr>
                  <tr>
                    <th>2022-11-20</th>
                    <td>
                      Mark <a href="#Asd">7778PV0129</a>
                    </td>
                    <td>100</td>
                    <td>0</td>
                    <td>user</td>
                  </tr>
                  <tr>
                    <th>2022-11-20</th>
                    <td>
                      Mark <a href="#Asd">7778PV0129</a>
                    </td>
                    <td>100</td>
                    <td>0</td>
                    <td>user</td>
                  </tr>
                  <tr>
                    <th>2022-11-20</th>
                    <td>
                      Mark <a href="#Asd">7778PV0129</a>
                    </td>
                    <td>100</td>
                    <td>0</td>
                    <td>user</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <QuickView
          trigger={this.state.showQuick}
          type={this.state.selectedType}
          id={this.state.selectedId}
          hideTrigger={this.SetshowQuick}
        />
      </div>
    );
  }
}
